<h2 mat-dialog-title>Confirm Delete?</h2>
<mat-dialog-content class="mat-typography">
  <h3>Warning, this is permanent?</h3>
  <p>Click Delete to confirm you want to proceed with this deletion.</p>
  
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Delete</button>
</mat-dialog-actions>

